/* Millimetre geometry shared by the designer and its regression checks. */
(function (root) {
  'use strict';
  const TAU = Math.PI * 2;
  function arrange(items, wristMm = 160) {
    const widths = items.map(b => Math.max(0.5, b.width));
    const run = widths.reduce((s, w) => s + w, 0);
    // Merchant's visual sizing convention: 150mm of components fills 15cm.
    // Do not add a bead-height allowance to the displayed cord circumference.
    const targetRadius = wristMm / TAU;
    const arc = (a, b, r) => 2 * Math.asin(Math.min(0.999, (a + b) / (4 * r)));
    const closure = r => widths.reduce((s, w, i) => s + arc(w, widths[(i + 1) % widths.length], r), 0);
    let radius = Math.max(targetRadius, ...widths.map(w => w / 2 + 0.1));
    if (items.length > 2) {
      let low = Math.max(...widths.map(w => w / 2 + 0.1)), high = Math.max(radius * 2, run);
      for (let i = 0; i < 60; i++) {
        const mid = (low + high) / 2;
        if (closure(mid) > TAU) low = mid; else high = mid;
      }
      // Solve a closed touching arrangement, then reserve space only while
      // the selected component run is below the nominal visual length.
      radius = high * Math.max(1, wristMm / run);
    }
    let theta = -Math.PI / 2;
    const positions = items.map((b, i) => {
      if (i) theta += arc(widths[i - 1], widths[i], radius);
      return { x: Math.cos(theta) * radius, y: Math.sin(theta) * radius,
        angle: theta * 180 / Math.PI, rotation: b.orient === 'tangent' ? theta * 180 / Math.PI + 90 + (b.rotation || 0) : (b.rotation || 0),
        width: b.width, height: b.height };
    });
    return { radius, positions, run, target: wristMm,
      fill: Math.min(1, run / wristMm),
      overflow: run > wristMm + 0.01 };
  }
  const api = { arrange };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.PyraBraceletGeometry = api;
})(typeof window === 'undefined' ? globalThis : window);
